import React, { useEffect, useMemo, useRef } from "react";
import {
    Form, FormGroup, Schema, DatePicker, SelectPicker,
    FormControl, IconButton, Icon, RadioGroup, Radio
} from "rsuite";
import { Collapse } from "react-collapse";
import styled from "styled-components";

import { DEFAULT_EQUAL_SIGN } from "const"
import FormHOC from "hoc/FilltersForm";
import Checkbox from "hoc/Checkbox";
import { FilterSectionFlexboxGrid, StyledItemFitWidth } from "components/base/FitContainers";
import Search, { str } from "components/Filters/Search";
import SDE from "components/Filters/SDE";
import DE from "components/Filters/DE";
import WZ from "components/Filters/WZ";
import NumbersDownloadDropdown from "./NumbersDownloadDropdown";
// import * as S from "./styled";
import "./Allocated.css";

const { StringType } = Schema.Types;

const prefixFiltersRules = {
    prefix: StringType().pattern(/^[0-9][\d]*$/, "The prefix must contain only digits")
        .maxLength(15, "The maximum is 15 characters"),
    mcc_mnc: StringType().pattern(/^[0-9][\d]*$/, "The mcc and mcc must contain only digits")
        // .minLength(3, "The minimum is 6 characters.")
        .maxLength(15, "The maximum is 15 characters"),
};
const numbersFiltersModel = Schema.Model({ str, ...prefixFiltersRules });
const prefixesFiltersModel = Schema.Model(prefixFiltersRules);


const NumbersFilters = React.forwardRef((
    {
        onChange,
        disabled,
        filters,
        onChangeFilters,
        currentDisplay,
        currentRangeNumber,
        onChangeGroup,
        isMobile,

        isGanTrunks,

        isTransitTrunks,

        downloadLoading,
        downloadDisabled,
        onDownloadNumbersCsv,
        onDownloadNumbersCsv1,
        onDownloadOnlyNumbersCsv,
        onDownloadOnlyNumbersCsv1,

    }, ref) => {

    let searchRef = useRef(null);

    const [showFilters, setShowFilters] = React.useState(false);
    const [searchInput, onChangeSearchInput] = React.useState(currentRangeNumber);
    const [formValue, onChangeFormValue] = React.useState({});
    const [startDateState, onChangeStartDate] = React.useState(null);
    const [equalSignState, onChangeEqualSign] = React.useState(DEFAULT_EQUAL_SIGN);
    const equalObject = { "<": -1, "=": DEFAULT_EQUAL_SIGN, ">": 1 };

    useEffect(() => {
        onChangeSearchInput(currentRangeNumber);
        if (searchRef && searchRef.current) {
            if (!currentRangeNumber) {
                searchRef.current.value = null;
            }
        }
    }, [currentRangeNumber]);

    useEffect(() => {
        equalSignState && onChangeEqualSign(DEFAULT_EQUAL_SIGN);
        onChangeStartDate(null);
    }, [currentDisplay]);

    const isSuppliersTrunks = (isTransitTrunks || isGanTrunks);

    const numbersFilters = useMemo(() => {
        return <FilterSectionFlexboxGrid controlable={!isMobile}>
            <StyledForm
                mb={20}
                formDefaultValue={filters || {}}
                model={numbersFiltersModel}
                ref={ref}
                readOnly={disabled}
                onChange={(value) => {
                    onChangeFormValue(value);
                    const equalSign = value.start_date_inequation || Number.isInteger(value.start_date_inequation)
                        ? parseInt(value.start_date_inequation)
                        : undefined;
                    let startDate = new Date(value.start_date);
                    const day = startDate.getDate();
                    const month = startDate.getMonth() + 1;
                    const year = startDate.getFullYear();
                    startDate = value.start_date
                        ? `${year}-${month < 10 ? "0" : ""}${month}-${day < 10 ? "0" : ""}${day}`
                        : undefined;
                    const filterObject = {
                        ...value,
                        // str: searchInput,
                        start_date: startDate,
                        start_date_inequation: startDate
                            ? startDateState ? parseInt(equalSign) : DEFAULT_EQUAL_SIGN
                            : undefined
                    };
                    onChange(filterObject);
                }}
            >
                <StyledItemFitWidth controlable={!isMobile} isMobile={isMobile}>
                    <StyledField>
                        <Search
                            name="str"
                            inputRef={searchRef}
                            disabled={disabled}
                            placeholder="Range/Number search"
                            onChange={(value) => onChangeSearchInput(value)}
                        />
                    </StyledField>

                    {!isGanTrunks && <StyledField>
                        <WZ disabled={disabled} />
                    </StyledField>}

                    {!isGanTrunks && <StyledField>
                        <DE disabled={disabled} />
                    </StyledField>}

                    {!isGanTrunks && <StyledField>
                        <SDE disabled={disabled} />
                    </StyledField>}

                    {currentDisplay === "trunk_number" &&
                        <StyledField>
                            <FormGroup style={{ marginRight: 10 }}>
                                <FormControl
                                    name="start_date"
                                    style={{ width: 150 }}
                                    accepter={DatePicker}
                                    placeholder="Enter Date"
                                    onChange={() => {
                                        onChangeStartDate(true);
                                    }}
                                    onClean={() => {
                                        onChangeStartDate(null);
                                        onChangeEqualSign(DEFAULT_EQUAL_SIGN);
                                    }}
                                    defaultValue={!startDateState && filters && filters.start_date}
                                    disabled={disabled}
                                />
                            </FormGroup>
                        </StyledField>
                    }

                    {currentDisplay === "trunk_number" &&
                        <StyledField>
                            <FormGroup>
                                <FormControl
                                    labelKey="label"
                                    valueKey="value"
                                    cleanable={false}
                                    searchable={false}
                                    value={equalSignState}
                                    accepter={SelectPicker}
                                    disabled={!startDateState || disabled}
                                    name="start_date_inequation"
                                    onChange={(value) => {
                                        onChangeEqualSign(value)
                                    }}
                                    data={Object.keys(equalObject).map(val => { return { value: equalObject[val], label: val } })}
                                />
                            </FormGroup>
                        </StyledField>
                    }
                    {!isSuppliersTrunks &&
                        <StyledField>
                            <Checkbox
                                disabled={disabled}
                                name="actual"
                                // checked={(filters || {}).actual === false}
                                defaultChecked={false}
                            >
                                Show outdated/revoked
                            </Checkbox>
                        </StyledField>
                    }
                </StyledItemFitWidth>
            </StyledForm>
        </FilterSectionFlexboxGrid>
    }, [currentDisplay, filters, disabled]);

    const transitTrunksFilters = useMemo(() => {
        return <FilterSectionFlexboxGrid controlable={!isMobile}>
            <Form
                defaultValue={filters || {}}
                model={prefixesFiltersModel}
                ref={ref}
                readOnly={disabled}
                onChange={(value) => {
                    onChangeFormValue(value);
                    const prefixValue = value.prefix;
                    const mccMncValue = value.mcc_mnc;

                    const filterObject = {
                        ...value,
                        prefix: prefixValue,
                        mcc_mnc: mccMncValue
                    };

                    onChange(filterObject);
                }}
            >
                <StyledItemFitWidth controlable={!isMobile} isMobile={isMobile}>
                    <StyledField>
                        <Search
                            name="prefix"
                            inputRef={searchRef}
                            onBlur={(event) => {
                                // event.target && event.target.name === "str" && event.target.focus();
                            }}
                            disabled={disabled}
                            placeholder="Prefix"
                        />
                    </StyledField>
                    <StyledField>
                        <FormGroup>
                            <FormControl
                                cleanable={false}
                                searchable={false}
                                disabled={disabled}
                                name="mcc_mnc"
                                placeholder="MCC MNC"
                            />
                        </FormGroup>
                    </StyledField>
                </StyledItemFitWidth>
            </Form>
        </FilterSectionFlexboxGrid>
    }, [currentDisplay, filters]);

    const ganTrunksFilters = useMemo(() => {
        return <FilterSectionFlexboxGrid controlable={!isMobile}>
            <Form
                defaultValue={filters || {}}
                model={numbersFiltersModel}
                ref={ref}
                readOnly={disabled}
                onChange={(value) => {
                    onChangeFormValue(value);

                    const filterObject = {
                        // str: searchInput,
                        ...value

                    };

                    onChange(value);
                }}
            >
                <StyledItemFitWidth controlable={!isMobile} isMobile={isMobile}>
                    <StyledField>
                        <Search
                            name="str"
                            inputRef={searchRef}
                            onBlur={(event) => {
                                // event.target && event.target.name === "str" && event.target.focus();
                            }}
                            disabled={disabled}
                            placeholder="Number/Group Name"
                            onChange={onChangeSearchInput}
                            style={{ "min-width": "200px" }}
                        />
                    </StyledField>

                    {currentDisplay === "numbers" &&
                        <StyledField>
                            <WZ disabled={disabled} />
                        </StyledField>
                    }
                    {currentDisplay === "numbers" &&
                        <StyledField>
                            <DE disabled={disabled} />
                        </StyledField>
                    }
                    {currentDisplay === "numbers" &&
                        <StyledField>
                            <SDE disabled={disabled} />
                        </StyledField>
                    }

                    {currentDisplay === "numbers" &&
                        <StyledField>
                            <Checkbox
                                disabled={disabled}
                                name="show_allocated_numbers"
                                // checked={(filters || {}).show_allocated_numbers === false}
                                defaultChecked={true}
                            >
                                Show allocated numbers
                            </Checkbox>
                        </StyledField>}
                    {currentDisplay === "numbers" &&
                        <StyledField>
                            <Checkbox
                                disabled={disabled}
                                name="show_unallocated_numbers"
                                // checked={(filters || {}).show_unallocated_numbers === false}
                                defaultChecked={true}
                            >
                                Show unallocated numbers
                            </Checkbox>
                        </StyledField>}
                    {currentDisplay === "numbers" &&
                        <StyledField>
                            <Checkbox
                                disabled={disabled}
                                name="show_test_numbers"
                                // checked={(filters || {}).show_test_numbers === false}
                                defaultChecked={true}
                            >
                                Show test numbers
                            </Checkbox>
                        </StyledField>}
                    {currentDisplay === "numbers" &&
                        <StyledField>
                            <Checkbox
                                disabled={disabled}
                                name="show_block_allocation_numbers"
                                // checked={(filters || {}).show_block_allocation_numbers === false}
                                defaultChecked={true}
                            >
                                Show block allocation numbers
                            </Checkbox>
                        </StyledField>}

                </StyledItemFitWidth>
            </Form>
        </FilterSectionFlexboxGrid>
    }, [currentDisplay, filters]);

    return (
        <>
            {/* refactor after ATX-2853 */}
            {isTransitTrunks ?
                transitTrunksFilters
                : isGanTrunks ?
                    ganTrunksFilters
                    : <></>}

            {!isSuppliersTrunks && isMobile &&
                <StyledIconButton
                    icon={<Icon icon="filter" />}
                    appearance={showFilters ? "primary" : "default"}
                    onClick={() => setShowFilters(!showFilters)}
                >
                </StyledIconButton>
            }

            {!isGanTrunks && isMobile &&
                <NumbersDownloadDropdown
                    loading={downloadLoading}
                    disabled={downloadDisabled}
                    onDownloadNumbersCsv={onDownloadNumbersCsv}
                    onDownloadNumbersCsv1={onDownloadNumbersCsv1}
                    onDownloadOnlyNumbersCsv={onDownloadOnlyNumbersCsv}
                    onDownloadOnlyNumbersCsv1={onDownloadOnlyNumbersCsv1}
                    isMobile={isMobile}
                />
            }

            {!isSuppliersTrunks && <Collapse isOpened={!isMobile || showFilters}>
                {numbersFilters}
                {isMobile &&
                    <RadioGroup
                        inline
                        onChange={onChangeGroup}
                        defaultValue={"trunk_number"}
                        name="radioList"
                    >
                        <Radio value="trunk_number" disabled={disabled}>Numbers</Radio>
                        <Radio value="price_range" disabled={disabled}>Ranges</Radio>
                        <Radio value="subdestination" disabled={disabled}>Subdestinations</Radio>
                    </RadioGroup>
                }
            </Collapse>}
        </>
    );
});

export default FormHOC(
    NumbersFilters,
    numbersFiltersModel,
    ({ isTransitTrunks, isGanTrunks }) => isTransitTrunks || isGanTrunks ? 1000 : 800,
    false
);

const StyledField = styled.div`
    display: inline-block;
    
    margin-right: 15px;
    margin-bottom: ${props => props.mb || 0}px;

    @media (max-width: 767px) {
        display: block;
        margin-right: 0;
        margin-bottom: 15px;

        .rs-form-control-wrapper {
            margin-bottom: 0px !important;
        }
        
        .rs-input {
            min-width: 30px;
        }
        
        && .rs-control-label {
            display: block;
            margin-bottom: 5px;
            margin-top: 0;
        }
        
        && .rs-form-group {
            display: block;
        }
    }
`;

const StyledForm = styled(Form)`
    && {
        margin-bottom: ${props => props.mb || 0}px;
    }
`;

const StyledIconButton = styled(IconButton)`
    && {
        margin-right: 15px;
    }
`;

// const FlexibleGrid = styled(S.Grid)`
//     && {
//         display: flex;
//         flex-flow: row wrap;
//     }

//     .rs-flex-box-grid-item:nth-child(4n) {
//         page-break-after: always;
//         break-after: always;
//         wrap-after: flex;
//     }
// `;
